import { render, staticRenderFns } from "./DisOrderNew.vue?vue&type=template&id=2302fb08&scoped=true&"
import script from "./DisOrderNew.vue?vue&type=script&lang=js&"
export * from "./DisOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./DisOrderNew.vue?vue&type=style&index=0&id=2302fb08&lang=less&scoped=scoped&"
import style1 from "./DisOrderNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2302fb08",
  null
  
)

export default component.exports